import '../../assets/index26.css';var re = Object.defineProperty, le = Object.defineProperties;
var se = Object.getOwnPropertyDescriptors;
var O = Object.getOwnPropertySymbols;
var W = Object.prototype.hasOwnProperty, j = Object.prototype.propertyIsEnumerable;
var N = (n, s, i) => s in n ? re(n, s, { enumerable: !0, configurable: !0, writable: !0, value: i }) : n[s] = i, _ = (n, s) => {
  for (var i in s || (s = {}))
    W.call(s, i) && N(n, i, s[i]);
  if (O)
    for (var i of O(s))
      j.call(s, i) && N(n, i, s[i]);
  return n;
}, D = (n, s) => le(n, se(s));
var E = (n, s) => {
  var i = {};
  for (var p in n)
    W.call(n, p) && s.indexOf(p) < 0 && (i[p] = n[p]);
  if (n != null && O)
    for (var p of O(n))
      s.indexOf(p) < 0 && j.call(n, p) && (i[p] = n[p]);
  return i;
};
import { jsxs as x, jsx as r, Fragment as ie } from "react/jsx-runtime";
import { forwardRef as ce, useState as pe, useRef as ae, useMemo as k, useCallback as ue } from "react";
import { ErrorMessage as de } from "../../molecules/ErrorMessage/index.js";
import { ComboboxChevron as fe } from "../../icons/ComboboxChevron.js";
import { Label as he } from "../Label/index.js";
import { Stack as be } from "../Stack/index.js";
import { Text as ge } from "../Text/index.js";
import { Button as me } from "../Button/index.js";
import { XMarkFarFAIcon as _e, CircleExclamationFarFAIcon as Se } from "../Icons/index.js";
import { ProgressIndicator as G } from "../ProgressIndicator/index.js";
import { g as ve, a as we, u as ye, C as h } from "../../Combobox-CmRRrGfX.js";
import { u as Ce } from "../../use-uncontrolled-BT_j5D2R.js";
import { I as M } from "../../InputBase-Cabx1d9o.js";
import { I as Oe } from "../../Input--FNE961U.js";
const xe = "Select-module__root___5RGau", Ie = "Select-module__inputBaseInput___CRl2G", Be = "Select-module__inputWrapper___VLLot", De = "Select-module__options___onC92", ke = "Select-module__option___HnZ5k", Pe = "Select-module__emptyState___wA-RT", Ae = "Select-module__clearButton___2bZ6X", f = {
  root: xe,
  inputBaseInput: Ie,
  inputWrapper: Be,
  options: De,
  option: ke,
  emptyState: Pe,
  clearButton: Ae
}, Fe = ce(
  (ze, V) => {
    var L = ze, {
      allowDeselect: n = !0,
      defaultValue: s,
      description: i,
      disabled: p,
      error: y,
      data: c,
      label: P,
      placeholder: A,
      onChange: X,
      value: Z,
      required: U,
      className: S,
      width: q,
      variant: u = "default",
      searchPlaceholder: Te = "Search...",
      clearable: J = !1,
      children: K,
      onSearch: I,
      onLoadMore: C,
      loading: F
    } = L, Q = E(L, [
      "allowDeselect",
      "defaultValue",
      "description",
      "disabled",
      "error",
      "data",
      "label",
      "placeholder",
      "onChange",
      "value",
      "required",
      "className",
      "width",
      "variant",
      "searchPlaceholder",
      "clearable",
      "children",
      "onSearch",
      "onLoadMore",
      "loading"
    ]);
    const [a, Y] = pe(null), v = !!C, T = ae({}), g = (t) => {
      u === "searchable" && (I == null || I(t), Y(t));
    }, w = k(() => ve(c), [c]), ee = k(() => u !== "searchable" || !a || v ? w : w.filter(
      (t) => {
        var e;
        return (e = t == null ? void 0 : t.label) == null ? void 0 : e.toLowerCase().includes(a.toLowerCase());
      }
    ), [w, a, u]), z = k(() => {
      const t = we(w);
      return v && Object.assign(T.current, t), v ? _(_({}, T.current), t) : t;
    }, [w, v]), l = ye({
      onDropdownClose: () => {
        l.resetSelectedOption();
      },
      onDropdownOpen: (t) => {
        t === "keyboard" ? l.selectActiveOption() : l.updateSelectedOptionIndex("active");
      }
    }), [b, B] = Ce({
      value: Z,
      defaultValue: s,
      onChange: X
    }), d = typeof b == "string" ? z[b] : void 0, oe = (t) => {
      const e = z[t];
      if (n && t === b) {
        B("", e), l.updateSelectedOptionIndex("active"), l.closeDropdown(), u === "searchable" && g("");
        return;
      }
      B(t, e), l.updateSelectedOptionIndex("active"), l.closeDropdown(), u === "searchable" && g((e == null ? void 0 : e.label) || "");
    }, te = (t) => {
      t.stopPropagation(), B("", void 0);
    }, ne = ue((t) => {
      if (!C) return;
      const e = t.currentTarget, m = e.scrollTop, o = e.scrollHeight, H = e.clientHeight;
      o - m - H < 10 && C(c == null ? void 0 : c.length);
    }, [C, c == null ? void 0 : c.length]), R = (() => {
      if (!c || c.length === 0) return [];
      if (!Array.isArray(c) || c.every((e) => typeof e == "string" || !("group" in e)))
        return ee.map((e, m) => /* @__PURE__ */ r(
          h.Option,
          {
            active: e.value === b,
            value: e.value,
            onMouseOver: () => l.selectOption(m),
            className: f.option,
            disabled: e.disabled,
            children: e.label
          },
          e.value
        ));
      let t = 0;
      return c.map((e) => {
        if (typeof e == "string" || !("group" in e)) {
          const o = typeof e == "string" ? { label: e, value: e } : e;
          return u !== "searchable" || !a || o.label.toLowerCase().includes(a.toLowerCase()) ? /* @__PURE__ */ r(
            h.Option,
            {
              active: o.value === b,
              value: o.value,
              onMouseOver: () => l.selectOption(t++),
              className: f.option,
              disabled: o.disabled,
              children: o.label
            },
            o.value
          ) : null;
        }
        const m = e.items.filter(
          (o) => u !== "searchable" || !a || (typeof o == "string" ? o : o.label).toLowerCase().includes(a.toLowerCase())
        );
        return m.length === 0 ? null : /* @__PURE__ */ r(h.Group, { label: e.group, children: m.map((o) => /* @__PURE__ */ r(
          h.Option,
          {
            active: (typeof o == "string" ? o : o.value) === b,
            value: typeof o == "string" ? o : o.value,
            onMouseOver: () => l.selectOption(t++),
            className: f.option,
            disabled: typeof o == "string" ? !1 : o.disabled,
            children: typeof o == "string" ? o : o.label
          },
          typeof o == "string" ? o : o.value
        )) }, e.group);
      }).filter(Boolean);
    })(), $ = _({
      disabled: p,
      rightSection: F ? /* @__PURE__ */ r(G, { size: "xs" }) : /* @__PURE__ */ r(fe, { size: "xs", error: y }),
      rightSectionPointerEvents: "none",
      label: /* @__PURE__ */ r(he, { label: P, withAsterisk: U }),
      description: i,
      descriptionProps: { c: "gray.8" },
      error: y && /* @__PURE__ */ r(de, { error: y }),
      inputWrapperOrder: ["label", "input", y ? "error" : "description"],
      classNames: {
        wrapper: `${f.inputWrapper} ${S ? S + "-wrapper" : ""}`,
        input: `${f.inputBaseInput} ${S ? S + "-input" : ""}`,
        root: `${f.root} ${S || ""}`
      },
      style: { width: q }
    }, Q);
    return /* @__PURE__ */ x(h, { store: l, onOptionSubmit: oe, withinPortal: !1, disabled: p, children: [
      /* @__PURE__ */ r(h.Target, { children: u === "searchable" ? /* @__PURE__ */ r(
        M,
        D(_({}, $), {
          value: a != null ? a : d == null ? void 0 : d.label,
          onChange: (t) => {
            l.dropdownOpened || l.openDropdown(), g(t.currentTarget.value), l.updateSelectedOptionIndex();
          },
          onClick: () => {
            g(""), l.openDropdown();
          },
          onFocus: () => {
            g(""), l.openDropdown();
          },
          onBlur: () => {
            l.closeDropdown(), g((d == null ? void 0 : d.label) || "");
          },
          placeholder: A
        })
      ) : /* @__PURE__ */ x(
        M,
        D(_({}, $), {
          component: "button",
          type: "button",
          onClick: () => l.toggleDropdown(),
          pointer: !0,
          ref: V,
          children: [
            (d == null ? void 0 : d.label) || /* @__PURE__ */ r(Oe.Placeholder, { children: A }),
            J && b && /* @__PURE__ */ r("div", { className: f.clearButton, children: /* @__PURE__ */ r(
              me,
              {
                variant: "tertiary",
                size: "sm",
                onClick: te,
                "aria-label": "Clear selection",
                children: /* @__PURE__ */ r(_e, {})
              }
            ) })
          ]
        })
      ) }),
      /* @__PURE__ */ x(h.Dropdown, { children: [
        /* @__PURE__ */ r(
          h.Options,
          {
            "aria-label": P,
            className: f.options,
            onScroll: v ? ne : void 0,
            children: R.length > 0 ? R : u === "searchable" && a ? /* @__PURE__ */ r(be, { className: f.emptyState, children: F ? /* @__PURE__ */ r(G, { size: "md" }) : /* @__PURE__ */ x(ie, { children: [
              /* @__PURE__ */ r(Se, { size: 24 }),
              /* @__PURE__ */ r(ge, { size: "md", prominent: !0, c: "gray.7", children: "No results found" })
            ] }) }) : null
          }
        ),
        K
      ] })
    ] });
  }
), Le = Object.assign(Fe, {
  Footer: h.Footer
});
Le.displayName = "Select";
export {
  Le as Select
};
